import { availableUser } from "../../../normalizr/usersSchema";
import { createEntityReducer } from "../../Entities/reducers";

export const usersReducer = createEntityReducer(availableUser.key, {
    initState: null,
    ignoreCleanEntities: true,
});
